module.exports = __webpack_public_path__ + "img/pic01.852b8509.jpg";